import "./index.scss";

import { OrgTransactionStates } from "graphql_globals";
import UpsertDocumentBundleInstructionMutation from "common/transactions/graphql/mutations/upsert_document_bundle_instruction_mutation.graphql";
import DeleteDocumentBundleInstructionMutation from "common/transactions/graphql/mutations/delete_document_bundle_instruction_mutation.graphql";
import { useMutation } from "util/graphql";

import NotaryInstructionsGrid from "./instruction";
import type { DocumentBundleForTransactionDetailsInstructions as DocumentBundle } from "./index_fragment.graphql";

type Props = {
  bundle: null | DocumentBundle;
  transaction: null | {
    id: string;
    state: OrgTransactionStates;
  };
  organization: null | {
    id: string;
    instructions: DocumentBundle["instructions"];
  };
  viewer: {
    user: null | { id: string; organization: null | { id: string } };
  };
  refetch: () => Promise<unknown>;
  isNotarizeAdmin?: boolean;
};

function transactionAllowsChangesToNotes({ state }: NonNullable<Props["transaction"]>): boolean {
  switch (state) {
    case OrgTransactionStates.SENT:
    case OrgTransactionStates.ACTIVE:
    case OrgTransactionStates.STARTED:
    case OrgTransactionStates.RECEIVED:
    case OrgTransactionStates.SENT_TO_CLOSING_OPS:
    case OrgTransactionStates.SENT_TO_TITLE_AGENCY:
    // @ts-expect-error -- from old JS, IDK if its used
    case "IN_PROGRESS":
    // @ts-expect-error -- from old JS, IDK if its used
    case "VIEWED":
      return true;
    default:
      return false;
  }
}

function InstructionDetails(props: Props) {
  const { bundle, organization, refetch, viewer, transaction, isNotarizeAdmin } = props;
  const upsertBundleInstructionMutateFn = useMutation(UpsertDocumentBundleInstructionMutation);
  const deleteDocumentBundleInstructionMutateFn = useMutation(
    DeleteDocumentBundleInstructionMutation,
  );
  const instructions = bundle?.instructions || organization!.instructions;
  const allowChangesToNotes = !transaction || transactionAllowsChangesToNotes(transaction);
  const organizationId = organization?.id || viewer.user!.organization?.id;

  return (
    <NotaryInstructionsGrid
      instructions={instructions}
      onDelete={async (instructionId) => {
        await deleteDocumentBundleInstructionMutateFn({
          variables: { input: { id: instructionId } },
        });
        return refetch();
      }}
      onSave={async (instruction) => {
        await upsertBundleInstructionMutateFn({
          variables: {
            input: {
              documentBundleId: bundle?.id,
              text: instruction.text,
              // Admins dont send organization id so they are the author (not the org)
              organizationId: isNotarizeAdmin ? null : organizationId,
              documentBundleInstructionId: instruction.id,
            },
          },
        });
        return refetch();
      }}
      allowChanges={allowChangesToNotes || isNotarizeAdmin}
    />
  );
}

export default InstructionDetails;
